import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { bootstrapAnalytics, trackPageview } from '../lib/analytics.js';

// Mount once near the root; fires gtag on initial load and every route change.
export function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => { bootstrapAnalytics(); }, []);
  useEffect(() => { trackPageview(pathname + search); }, [pathname, search]);
  return null;
}
